import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import HeaderPage from "../components/HeaderPage";
import BoletinForm from "../components/Boletin/BoletinForm";
import BoletinList from "../components/Boletin/BoletinList";
import BoletinListStudentView from "../components/Boletin/BoletinListStudentView";
import BoletinAdminView from "../components/Boletin/BoletinAdminView";
import Notification from "../components/Notification";

import { useAuth } from "../context/AuthContext";
import { useBoletin } from "../context/BoletinContext";
import { useUsers } from "../context/UsersContext";
import { useNotas } from "../context/NotasContext";

const BoletinPage = () => {
  const { user } = useAuth();
  const { boletines, fetchBoletines, generarBoletin, fetchBoletinesByDirector, loading } = useBoletin();
  const { students, fetchStudentsByDirector } = useUsers();
  const { periodos, fetchPeriodos } = useNotas();

  // const [boletines, setBoletines] = useState([]);
  const [editingBoletin, setEditingBoletin] = useState(null);
  const [notification, setNotification] = useState(null);

  const closeNotification = () => setNotification(null);

  useEffect(() => {
    if (user?.rol_id === 1) {
      fetchBoletines();
    } else if (user?.rol_id === 2) {
      fetchStudentsByDirector(user.id);
      fetchBoletinesByDirector(user.id);
      // fetchBoletines();
      fetchPeriodos();
    } else if (user?.rol_id === 3) {
      fetchBoletines()
    }
  }, [user]);

  

  const handleEdit = (boletin) => {
    setEditingBoletin(boletin);
  };


  const handleGenerarPDF = async (studentId, periodoId, grado) => {
    try {
      await generarBoletin(studentId, periodoId, grado);
      setNotification({
        type: "success",
        message: "Boletín generado correctamente.",
      });
    } catch (error) {
      setNotification({
        type: "error",
        message: error.response?.data?.message || "Error al generar el PDF.",
      });
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-6 overflow-y-auto">
        <HeaderPage title="Gestión de Boletines" />
        {loading ? (
          <p className="text-center text-xl font-semibold">Generando Boletín...</p>
        ) : user?.rol_id === 3 ? (
          <BoletinListStudentView boletines={boletines} />
        ) : user?.rol_id === 1 ? (
          <BoletinAdminView boletines={boletines} />
        ) : (
          <>
            <BoletinForm
              students={students}
              periodos={periodos}
              showNotification={setNotification}
              editingBoletin={editingBoletin}
              clearEditing={() => setEditingBoletin(null)}
              onBoletinGuardado={() => fetchBoletinesByDirector(user.id)}
            />
            <BoletinList
              boletines={boletines}
              onEdit={handleEdit}              
              onGenerarPDF={handleGenerarPDF}
              showNotification={setNotification}
              userId={user?.id}
            />
          </>
        )}
      </div>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={closeNotification}
        />
      )}
    </div>
  );
};

export default BoletinPage;
